import React, {useState} from 'react';
import {Input} from "reactstrap";
import "./index.css";
import HomeCardComponent from "../../clipstore/user/home/card";
import {clipstoreContentPriceList} from "../../../util/broadcaster/profile_util";

AttachmentPriceSelectionItem.propTypes = {};

function AttachmentPriceSelectionItem(props) {

    const contentPriceOptionTemplate = clipstoreContentPriceList().map((v) => (
        <option key={v} value={v}>
            {`£ ${v}`}
        </option>
    ));

    const [type, setType] = useState(props.content.price.type);
    const [amount, setAmount] = useState(props.content.price.amount);

    return (
        <div className="display-flex attachment-price-selection-container">
            <div>
                <HomeCardComponent
                    openBroadcasterProfile={() => {
                    }}
                    showBroadcasterSection={false}
                    selectCard={() => {
                    }}
                    openDetail={() => {
                    }}
                    content={props.content}
                    key={`attachment-price-selection-${props.index}`}/>
            </div>
            <div className="attachment-price-selection-col2">
                <dt className="label-14 attachment-price-selection-col2-label">Content Type</dt>
                <dd>
                    <label className="broadcastType">
                        <div className="form-group">
                            <label className="custom-radio-btn-container">Free
                                <input
                                    type="radio"
                                    name={`radio-${props.content.id}`}
                                    checked={props.content.price.type === "free"}
                                    onChange={() => {
                                        console.log("onClick >> Free")
                                        setType("free")
                                        props.updatePricingInSelectedItemsArray(props.index,"free",amount)
                                    }}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    </label>
                    <label className="broadcastType">
                        <div className="form-group">
                            <label className="custom-radio-btn-container">Paid
                                <input
                                    type="radio"
                                    name={`radio-${props.content.id}`}
                                    checked={props.content.price.type === "paid"}
                                    onChange={() => {
                                        console.log("onClick >> Paid")
                                        setType("paid")
                                        props.updatePricingInSelectedItemsArray(props.index,"paid",amount)
                                    }}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    </label>
                </dd>

                <div>
                    <dt className="label-14 attachment-price-selection-col2-label">Entire Content Price</dt>
                    <dd>
                        <label className="broadcastType">
                            <div className="form-group">
                                <Input
                                    type="select"
                                    name={`select-${props.content.id}`}
                                    onChange={(e) => {
                                        console.log("select",e.target.value)
                                        const value = parseFloat(e.target.value) * 100;
                                        setAmount(value)
                                        props.updatePricingInSelectedItemsArray(props.index,type,value)
                                    }}>
                                    {contentPriceOptionTemplate}
                                </Input>
                            </div>
                        </label>
                    </dd>
                </div>

            </div>
        </div>
    );
}

export default AttachmentPriceSelectionItem;